export function getContext() {
	return window.contextPath || '';
}

export default {
	getContext,
};
